import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
// import { convertCurrencyHelper } from '../../../helpers/forexConvertor';
import typeOfContract from '../../../../constants/typeOfContract.js';
import { clientHighestRevenue } from './Services/reportRevenue.js';

// Functional component
function ReportHighestRevenue(props) {
  const [displayedRevenue, setDisplayedRevenue] = useState(0);
  const [targetRevenue, setTargetRevenue] = useState(0);
  const [clientName, setClientName] = useState('');
  const animationFrameRef = useRef(null);
  const reportingRevenue = useSelector((state) => state.reportingRevenue);
  const { forex } = useSelector((state) => state.forex);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const clientInvoices = props.clientInvoices;
  const trackReport = props.trackReport;
  const projectCost = props.projectCost;
  const expenses = props.expenses;
  const setReportingCurrency = useSelector((state) => state.reportingRevenue.revenueCurrency);
  var currencies = "USD";
  if (setReportingCurrency && setReportingCurrency.length === 1) {
    currencies = setReportingCurrency[0];
  } else {
    currencies = settings?.currency || "USD";
  }

  useEffect(() => {
    if (
      trackReport && 
      Array.isArray(trackReport) && 
      projectCost && 
      Array.isArray(projectCost) && 
      clientInvoices && 
      Array.isArray(clientInvoices) && 
      expenses && 
      Array.isArray(expenses) &&
      reportingRevenue && 
      currencies && 
      forex
    ) {
      try {
        const highestClient = clientHighestRevenue(trackReport, projectCost, clientInvoices, reportingRevenue, currencies, forex, typeOfContract, expenses);
        
        if (highestClient && highestClient.revenue !== undefined && highestClient.revenue !== null) {
          const parsedRevenue = parseFloat(highestClient.revenue) || 0;
          if (!isNaN(parsedRevenue)) {
            setTargetRevenue(parsedRevenue);
            setClientName(highestClient.details?.client_name || '');
          } else {
            setTargetRevenue(0);
            setClientName('');
          }
        } else {
          setTargetRevenue(0);
          setClientName('');
        }
      } catch (error) {
        console.error('Error calculating highest revenue:', error);
        setTargetRevenue(0);
        setClientName('');
      }
    } else {
      setTargetRevenue(0);
      setClientName('');
    }
  }, [reportingRevenue, forex, currencies, trackReport, projectCost, expenses, clientInvoices]);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedRevenue;
    const endValue = targetRevenue;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedRevenue(parseFloat(currentValue.toFixed(2)));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedRevenue(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetRevenue]);

  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">
            Highest Revenue
            {clientName && <div className='client-name-report'>{clientName}</div>}
          </div>
          <div className="overview-icon">
            <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_2951_47)">
                <circle cx="24.5" cy="24.5" r="20.5" fill="white" />
              </g>
              <path d="M19.3298 8C18.5999 8 17.9012 8.27964 17.4019 8.78637C17.3319 8.85729 17.2864 8.94817 17.2719 9.04603C17.2575 9.14389 17.2748 9.24374 17.3214 9.33135L18.8226 12.8493C18.351 13.174 18.0404 13.7103 18.0404 14.3155C18.0404 14.64 18.1293 14.9448 18.2849 15.2084C14.5326 17.5846 12 22.5995 12 26.5193C12 31.7726 16.7309 36 22.5019 36C28.2729 36 33 31.7726 33 26.5193C33 22.5986 30.4685 17.5831 26.7151 15.2074C26.8699 14.944 26.9596 14.6397 26.9596 14.3155C26.9596 13.7105 26.6505 13.1741 26.1802 12.8493L27.6776 9.33795C27.7263 9.24999 27.7452 9.14901 27.7314 9.04978C27.7176 8.95054 27.6719 8.85824 27.6009 8.78637C27.1017 8.27964 26.403 8 25.6731 8C24.9432 8 24.2416 8.27964 23.7424 8.78637C23.4317 9.10177 22.9805 9.28892 22.5019 9.28892C22.0313 9.28892 21.5832 9.10834 21.2729 8.8024C21.268 8.79693 21.2628 8.79157 21.2576 8.78634C20.7584 8.27961 20.0597 8 19.3298 8ZM19.3298 8.93911C19.8084 8.93911 20.2634 9.12626 20.5741 9.44167C21.0733 9.94841 21.772 10.229 22.5019 10.229C23.2318 10.229 23.9295 9.94841 24.4288 9.44167C24.434 9.43644 24.4391 9.43109 24.4441 9.42562C24.7544 9.11966 25.2025 8.93909 25.6731 8.93909C26.0427 8.93909 26.3958 9.05135 26.6806 9.24741L25.2801 12.5296C25.2319 12.5258 25.1835 12.523 25.1343 12.523H19.8685C19.8194 12.523 19.771 12.5258 19.7228 12.5296L18.3194 9.24932C18.6046 9.05208 18.959 8.93911 19.3298 8.93911ZM19.8685 13.4621H25.1343C25.6265 13.4621 26.0077 13.8335 26.0077 14.3155C26.0077 14.7974 25.6265 15.1716 25.1343 15.1716H19.8685C19.3764 15.1716 18.9952 14.7974 18.9952 14.3155C18.9952 13.8335 19.3764 13.4621 19.8685 13.4621ZM18.9856 15.8844C19.2482 16.028 19.5489 16.1107 19.8685 16.1107H25.1343C25.4542 16.1107 25.755 16.0283 26.0173 15.8844C29.4927 17.9834 32.0452 22.952 32.0452 26.5193C32.0452 31.2173 27.8013 35.0599 22.5019 35.0599C17.2025 35.0599 12.9548 31.2173 12.9548 26.5193C12.9548 22.952 15.5101 17.9834 18.9856 15.8844ZM22.5019 19.8785C22.4389 19.8783 22.3765 19.8903 22.3182 19.9139C22.2599 19.9375 22.207 19.9722 22.1624 20.016C22.1179 20.0599 22.0826 20.1119 22.0586 20.1693C22.0346 20.2266 22.0223 20.288 22.0226 20.35V21.2429C20.7248 21.4417 19.6931 22.434 19.6931 23.6812C19.6931 25.0785 20.9887 26.1553 22.5019 26.1553C23.5642 26.1553 24.355 26.8709 24.355 27.6875C24.355 28.5041 23.5642 29.2235 22.5019 29.2235C21.5746 29.2235 20.8253 28.6585 20.6757 27.9543C20.6629 27.8937 20.6381 27.8361 20.6026 27.785C20.5671 27.7338 20.5217 27.69 20.469 27.6562C20.4162 27.6224 20.3572 27.5991 20.2953 27.5878C20.2333 27.5765 20.1698 27.5774 20.1082 27.5904C19.9842 27.6158 19.8756 27.6886 19.8062 27.7927C19.7369 27.8969 19.7124 28.0238 19.7381 28.1458C19.962 29.1991 20.9008 29.9569 22.0226 30.1268V31.0225C22.0228 31.0842 22.0354 31.1452 22.0597 31.2021C22.0839 31.2589 22.1193 31.3106 22.1638 31.354C22.2083 31.3974 22.2611 31.4318 22.3191 31.4552C22.3771 31.4785 22.4392 31.4904 22.5019 31.4902C22.6279 31.4897 22.7485 31.4402 22.8376 31.3526C22.9266 31.265 22.9769 31.1464 22.9774 31.0225V30.1268C24.2766 29.929 25.3098 28.9357 25.3098 27.6875C25.3098 26.2902 24.0151 25.2162 22.5019 25.2162C21.4397 25.2162 20.6479 24.4978 20.6479 23.6812C20.6479 22.8646 21.4397 22.1452 22.5019 22.1452C23.4293 22.1452 24.1775 22.713 24.3272 23.4172C24.353 23.5389 24.4268 23.6455 24.5325 23.7138C24.6382 23.782 24.767 23.8062 24.8909 23.7811C24.9525 23.7686 25.011 23.7441 25.0631 23.7092C25.1151 23.6743 25.1596 23.6297 25.194 23.5778C25.2284 23.5259 25.252 23.4678 25.2635 23.4069C25.275 23.346 25.2741 23.2835 25.2609 23.2229C25.0369 22.1687 24.0998 21.411 22.9774 21.2419V20.35C22.9777 20.2883 22.9656 20.2272 22.9418 20.1701C22.918 20.1131 22.8831 20.0612 22.8389 20.0174C22.7948 19.9736 22.7423 19.9388 22.6845 19.915C22.6266 19.8912 22.5646 19.8788 22.5019 19.8785Z" fill="#6A7988" stroke="#6A7988" strokeWidth="0.1" />
              <path d="M37.5 33.5C37.5 36.2614 35.2614 38.5 32.5 38.5C29.7386 38.5 27.5 36.2614 27.5 33.5C27.5 30.7386 29.7386 28.5 32.5 28.5C35.2614 28.5 37.5 30.7386 37.5 33.5Z" fill="white" />
              <path fillRule="evenodd" clipRule="evenodd" d="M32.5 29C30.0147 29 28 31.0147 28 33.5C28 35.9853 30.0147 38 32.5 38C34.9853 38 37 35.9853 37 33.5C37 31.0147 34.9853 29 32.5 29ZM27 33.5C27 30.4624 29.4624 28 32.5 28C35.5376 28 38 30.4624 38 33.5C38 36.5376 35.5376 39 32.5 39C29.4624 39 27 36.5376 27 33.5Z" fill="#6A7988" />
              <path d="M33.5242 30.9431C32.9555 30.3524 32.0327 30.3522 31.4646 30.9432L29.5 32.987L30.2797 33.798L31.9533 32.057V36.5H33.056V32.078L34.7203 33.8086L35.5 32.9975L33.5242 30.9431Z" fill="#6A7988" />
              <defs>
                <filter id="filter0_d_2951_47" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2951_47" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2951_47" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>

        <div className="overview-rice">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencies,
          }).format(displayedRevenue)}
        </div>
      </div>

    </div>
  );
}

export default ReportHighestRevenue;
